import React from 'react';
import PropTypes from 'prop-types';
import useIterateModifiers from '@/hooks/useIterateModifiers';

const Breadcrumb = ({ crumbs, modifiers }) => {
  const modifiersString = useIterateModifiers(' dln-breadcrumbs--', modifiers);
  return (
    <div className={`dln-breadcrumbs${modifiersString}`}>
      <ol>
        {crumbs.map(crumb => {
          const finalCrumb = crumb.url ? (
            <a href={crumb.url}>{crumb.text}</a>
          ) : (
            <span>{crumb.text}</span>
          );
          return (
            <li
              key={crumb.text}
              className={`dln-breadcrumbs__li${crumb.active ? ' active' : ''}`}
            >
              {crumb.onClick ? (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a
                  href='#'
                  onClick={e => {
                    e.preventDefault();
                    crumb.onClick(e);
                  }}
                >
                  {crumb.text}
                </a>
              ) : (
                finalCrumb
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
};

Breadcrumb.propTypes = {
  crumbs: PropTypes.arrayOf(PropTypes.shape).isRequired,
  modifiers: PropTypes.arrayOf(PropTypes.string),
};

Breadcrumb.defaultProps = {
  modifiers: [],
};

export default Breadcrumb;
